import { _ as _defineProperty, a as _inherits, b as _createClass, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.map.js';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import shortcuts from './core.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.find-index.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.string.match.js';
import 'combokeys';
import '../global/sniffer.js';
import 'sniffr';

var Shortcuts = /*#__PURE__*/function (_PureComponent) {
  function Shortcuts() {
    _classCallCheck(this, Shortcuts);
    return _callSuper(this, Shortcuts, arguments);
  }
  _inherits(Shortcuts, _PureComponent);
  return _createClass(Shortcuts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.turnShorcutsOn();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        map = _this$props.map;
      if (!prevProps.disabled && disabled) {
        this.turnShorcutsOff();
      }
      if (prevProps.disabled && !disabled) {
        this.turnShorcutsOn();
      }
      if (prevProps.map !== map) {
        shortcuts.bindMap(map, this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.disabled) {
        this.turnShorcutsOff();
      }
    }
  }, {
    key: "turnShorcutsOn",
    value: function turnShorcutsOn() {
      var _this$props2 = this.props,
        map = _this$props2.map,
        scope = _this$props2.scope,
        options = _this$props2.options;
      shortcuts.bindMap(map, this.props);
      shortcuts.pushScope(scope, options);
    }
  }, {
    key: "turnShorcutsOff",
    value: function turnShorcutsOff() {
      var scope = this.props.scope;
      shortcuts.unbindScope(scope);
      shortcuts.spliceScope(scope);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);
}(PureComponent);
_defineProperty(Shortcuts, "propTypes", {
  map: PropTypes.object.isRequired,
  scope: PropTypes.string.isRequired,
  options: PropTypes.object,
  disabled: PropTypes.bool,
  children: PropTypes.node
});
_defineProperty(Shortcuts, "defaultProps", {
  options: {}
});

export { Shortcuts as default };
